import React, { useState } from 'react';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';

const Contactus = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  return (
    <div className="min-h-screen pt-16 bg-gradient-to-br from-gold-primary/90 to-gold-secondary/90">
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold mb-8 text-center text-black">Contact Us</h1>
        
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Contact Information */}
          <div className="bg-white/95 backdrop-blur-sm p-8 rounded-lg shadow-lg border border-gold-secondary/20">
            <h2 className="text-2xl font-semibold mb-6 text-black">Get in Touch</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-2">
                <MdLocationOn className="text-xl mt-0.5 flex-shrink-0 text-gold-primary" />
                <div>
                  <h3 className="font-medium text-gold-primary">Address</h3>
                  <p className="text-gold-secondary">VTP Towers, No. 205, GNT Road, Erukkanchery, Chennai - 600118, Tamil Nadu</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <MdEmail className="text-xl mt-0.5 flex-shrink-0 text-gold-primary" />
                <div>
                  <h3 className="font-medium text-gold-primary">Email</h3>
                  <a 
                    href="mailto:ohm.interiors@outlook.com" 
                    className="text-gold-secondary hover:text-gold-primary transition-colors"
                  >
                    ohm.interiors@outlook.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <MdPhone className="text-xl mt-0.5 flex-shrink-0 text-gold-primary" />
                <div>
                  <h3 className="font-medium text-gold-primary">Phone</h3>
                  <a 
                    href="tel:+917090011444" 
                    className="text-gold-secondary hover:text-gold-primary transition-colors block"
                  >
                    +91 7090011444
                  </a>
                  <a 
                    href="tel:+919340011444" 
                    className="text-gold-secondary hover:text-gold-primary transition-colors block"
                  >
                    +91 9340011444
                  </a>
                </div>
              </div>
              <div className="mt-4">
                <h3 className="font-medium text-gold-primary mb-2">Location</h3>
                <div className="w-full h-[200px] rounded-lg overflow-hidden border border-gold-secondary/20">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3899.106290696656!2d80.24616786613726!3d13.123469047957053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265a169215555%3A0x5576175c9e63221f!2sOhm%20Interiors%20%26%20Doors!5e0!3m2!1sen!2sin!4v1748868304410!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="OHM Interiors Location"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white/95 backdrop-blur-sm p-8 rounded-lg shadow-lg border border-gold-secondary/20">
            <h2 className="text-2xl font-semibold mb-6 text-black">Send us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gold-primary">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gold-secondary/30 shadow-sm focus:border-gold-primary focus:ring-gold-primary bg-gold-light h-12 px-4"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gold-primary">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gold-secondary/30 shadow-sm focus:border-gold-primary focus:ring-gold-primary bg-gold-light h-12 px-4"
                  required
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gold-primary">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gold-secondary/30 shadow-sm focus:border-gold-primary focus:ring-gold-primary bg-gold-light h-12 px-4"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gold-primary">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="mt-1 block w-full rounded-md border-gold-secondary/30 shadow-sm focus:border-gold-primary focus:ring-gold-primary bg-gold-light"
                  required
                ></textarea>
              </div>
              <div className="mt-8">
                <button
                  type="submit"
                  className="w-full bg-gold-primary text-gold-white py-3 px-4 rounded-md hover:bg-gold-secondary transition-colors text-lg font-medium"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactus;
